import { PickupEventVariant } from "./types";

export const getEventLabels = (
  variant: PickupEventVariant,
  translate: (key: string, params?: any) => string,
) => {
  const isWps = variant === "wps";

  return {
    checkIn: isWps ? translate("checkin.title") : "Pickup",
    pageTitle: isWps ? translate("checkin.events") : "Pickup Events",
    detailTitle: isWps ? translate("checkin.detail-event") : "Pickup Event Detail",
    editTitle: isWps ? translate("checkin.edit-event") : "Edit Pickup Event",
    no: isWps ? translate("checkin.no") : "No",
    eventName: isWps ? translate("checkin.event-name") : "Event name",
    events: isWps ? translate("checkin.events") : "Event Name",
    eventPlaceholder: isWps ? translate("checkin.event-options-placeholder") : "Select Event",
    startDate: isWps ? translate("checkin.start-date") : "Start date",
    display: isWps ? translate("checkin.display") : "Display",
    action: isWps ? translate("action") : "Action",
    search: translate("search"),
    edit: translate("edit"),
    cancel: isWps ? translate("btn-cancel") : "Cancel",
    save: isWps ? translate("btn-save") : "Save",
    eventDisplay: isWps ? translate("checkin.event-display") : "Enable Event Display",
    signRequired: isWps ? translate("checkin.sign-required") : "Sign required",
    mapBibOnsite: isWps ? translate("checkin.map-bib-onsite") : "Map BIB onsite",
    printStamp: isWps ? translate("checkin.print-stamp") : "Print stamp",
    ewaiverTerm: isWps ? translate("checkin.ewaiver-term") : "Ewaiver term",
    eventBanner: "Event Banner",
    requiredMessage: isWps ? translate("error-field-require") : "This field is required",
    noData: isWps ? translate("no-data") : "No data",
    toggleConfirm: isWps
      ? translate("checkin.toggle-event-active")
      : "Are you sure you want to update this event display?",
    updateSuccess: "Update successfully",
    editSuccess: isWps ? translate("edit-successfully") : "Edit successfully",
    imageHint:
      "Recommended image size: 1440 x 600px - Maximum file size: 2MB - Supported image files: PNG, JPEG, JPG",
  };
};
